export enum ReasonForDisconnectionEnum {
  Deconstruction = 'Deconstruction',
  Relocation = 'Relocation',
  Vacancy = 'Vacancy',
  Other = 'Other'
}

export const ReasonForDisconnectionDisplayNames: Record<ReasonForDisconnectionEnum, string> = {
  [ReasonForDisconnectionEnum.Deconstruction]: 'Abriss',
  [ReasonForDisconnectionEnum.Relocation]: 'Umstellung',
  [ReasonForDisconnectionEnum.Vacancy]: 'Leerstand',
  [ReasonForDisconnectionEnum.Other]: 'Sonstiges'
};
